import { useState } from 'react';
import './MaterialOrderGrid.scss';
import {
    Column,
    Format,
    Item,
    Lookup
} from 'devextreme-react/data-grid';

import { useGetMaterialOrders } from "../api/get-material-orders";
import { MaterialOrderGridProps } from '../types/MaterialOrderGridProps';
import { useGetOrderStatuses } from '../../../../api/lookup';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { ClosedOrdersControl } from '../../../common';
import OrderTypeSelector from '../../order-type-selector/components/OrderTypeSelector';

export default function MaterialOrderGrid(props: MaterialOrderGridProps) {

    let [closedOrdersState, setClosedOrdersState] = useState<{ closedOrders: boolean, dateFrom: Date | null }>
        ({ closedOrders: false, dateFrom: null });

    const orders = useGetMaterialOrders(closedOrdersState.closedOrders, closedOrdersState.dateFrom);
    const orderStatuses = useGetOrderStatuses();

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    return (
        <div className='dx-card wide-card'>
            <OrderTypeSelector />
            <SyncDataGrid
                stateStorageKey='material-order-grid'
                dataSource={orders.data}
                keyExpr={'materialOrderID'}
                height="60vh"
                additionalToolbarItems={[
                    <Item
                        location={'before'}
                        key="closed-orders"
                    >
                        <ClosedOrdersControl
                            onClosedOrdersChanged={(e) => {
                                setClosedOrdersState({ closedOrders: e.checked, dateFrom: e.dateFrom })
                            }}
                        />
                    </Item >
                ]}
            >
                <Column
                    dataField={'moNumber'}
                    caption={'Material Order #'}
                    dataType="string"
                    cellRender={(cell: any) => {
                        if (cell.data.retailOrderID)
                            return <Link to={`/cfi/retail-order/${cell.data.retailOrderID}/130/${cell.data.materialOrderID}?returnUrl=${returnUrl}`}>
                                {cell.data.moNumber}
                            </Link>;
                        else
                            return <Link to={`/cfi/material-order/${cell.data.materialOrderID}?returnUrl=${returnUrl}`}>
                                {cell.data.moNumber}
                            </Link>;
                    }}
                />
                <Column
                    dataField={'roNumber'}
                    caption={'Retail Order #'}
                    dataType="string"
                    cellRender={(cell: any) => {
                        return <Link to={`/cfi/retail-order/${cell.data.retailOrderID}?returnUrl=${returnUrl}`}>
                            {cell.data.roNumber}
                        </Link>;
                    }} />
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'COMPONumber'}
                    caption={'CFI Material PO #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'orderStatus'}
                    caption={'Order Status'}
                    dataType="string"
                >
                    <Lookup
                        dataSource={orderStatuses.data}
                        valueExpr={'description'}
                        displayExpr={'description'}
                    />
                </Column>
                <Column
                    dataField={'moDate'}
                    caption={'Material Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'shipToLocation'}
                    caption={'Ship To Location'}
                    dataType="string"
                />
                <Column
                    dataField={'amount'}
                    caption={'Order Amount'}
                    dataType="number"
                    editorOptions={{ format: '$#,##0.##', showClearButton: true }}
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />

        </div>
    )
} 
